module.exports = __webpack_public_path__ + "assets/img/btn-view-bce6eccd.png";